var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSk = function SvgSk(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21787_20901",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#4171CF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21787_20901)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#D94837"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    width: 6.66667,
    height: 20,
    transform: "rotate(90 20 0)",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 6.66602,
    width: 6.66667,
    height: 20,
    transform: "rotate(90 20 6.66602)",
    fill: "#1B42B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4992 4.54505C7.54189 4.44351 4.71875 4.54542 3.5 4.54493V4.5496C3.50007 8.94488 3.50009 10.0452 3.76389 10.9705C4.61643 13.6564 6.35957 14.4588 7.5 14.5449C10.5 14.0449 11.5 11.0449 11.4992 4.54505Z",
    fill: "#D94837"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5901 12.3025C10.1864 11.5723 9.50895 10.6318 8.86011 11.04C8.49354 11.2706 8.29629 11.6159 8.29629 11.6159C8.29629 11.6159 8.20794 10.5449 7.3749 10.5449C6.54186 10.5449 6.30016 11.6159 6.30016 11.6159C6.30016 11.6159 6.24202 11.04 5.39461 11.04C4.95768 11.04 4.50449 11.5763 4.16797 12.096C4.83734 14.0711 5.89685 14.943 7.24468 15.5049C9.03944 14.621 10.0364 13.6407 10.5901 12.3025Z",
    fill: "#1B42B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14922 6.35V10.5268H7.59922V6.35L8.04922 5H6.69922L7.14922 6.35Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.69766 7.24922H8.33943V6.79922H6.69766L5.34766 6.34922V7.69922L6.69766 7.24922Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98984 7.24922H6.34807V6.79922H7.98984L9.33984 6.34922V7.69922L7.98984 7.24922Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.40078 8.95039H8.04256V8.50039H6.40078L5.05078 8.05039V9.40039L6.40078 8.95039Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29062 8.95039H6.64885V8.50039H8.29062L9.64062 8.05039V9.40039L8.29062 8.95039Z",
    fill: "#F6F8FA"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSk);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sk.6d67c493b01a3c7b97305789b6a28046.svg";